export const themeColors: Record<string, string> = {
  primary: '#206683',
  'primary-light': '#6A98AC',
  'primary-dark': '#17485d',
  'primary-opacity-8': '#edf3f5',
  'primary-50': '#D4F1FF',
  'primary-200': '#8EBAD4',
  'primary-600': '#206583',
  'primary-700': '#0D526D',
  secondary: '#ec6661',
  'secondary-light': '#f29895',
  'secondary-dark': '#a84845',
  error: '#ec6661',
  'error-light': '#f29895',
  'error-dark': '#a84845',
  success: '#4CAF50',
  'success-light': '#7BC67E',
  'success-dark': '#3B873E',
  'success-badge': '#27ab6e',
  warning: '#FF9800',
  'warning-light': '#FFB547',
  'warning-dark': '#C77700',
  'warning-background': '#FDF4E7',
  background: '#F5F5F7',
  'background-disabled': '#D5D7DA',
  'bg-active': '#E9EAEB',
  surface: '#FFFFFF',
  'primary-text': '#0D2B37',
  'secondary-text': '#667085',
  'on-background': '#0D2B37',
  'on-surface': '#0D2B37',
  disabled: '#506176',
  'action-active': '#98A2B3',
  'grey-50': '#FAFAFA',
  'grey-100': '#F5F5F5',
  'grey-200': '#EEEEEE',
  'grey-300': '#E0E0E0',
  'grey-400': '#BDBDBD',
  'grey-500': '#9E9E9E',
  'grey-600': '#757575',
  'grey-700': '#616161',
  'grey-800': '#424242',
  'grey-900': '#212121',
  'mobile-menu-icon': '#1E2134',
  subtitle: '#535862',
  'consultation-card-dark': '#0D526D',
  'consultation-card': '#206583',
  'tree-item': '#414651',
  'tree-node': '#A4A7AE',
  'fg-disabled': '#717680',
  'utility-blue-50': '#EFF8FF',
  'utility-blue-200': '#B2DDFF',
  'utility-blue-700': '#175CD3',
  'border-primary': '#D5D7DA',
  'text-error-primary': '#D92D20',

  // Design Foundation - colors
  'brand-25': '#EAF9FF',
  'brand-50': '#D4F1FF',
  'brand-100': '#B0D8EE',
  'brand-200': '#8EBAD4',
  'brand-300': '#6A9EBA',
  'brand-400': '#4F88A7',
  'brand-500': '#2F7494',
  'brand-600': '#206583',
  'brand-700': '#0D526D',
  'brand-800': '#003F57',
  'brand-900': '#002D40',
  'brand-950': '#001A2B',

  'error-25': '#FFFBFA',
  'error-50': '#FEF3F2',
  'error-100': '#FEE4E2',
  'error-200': '#FECDCA',
  'error-300': '#FDA29B',
  'error-400': '#F97066',
  'error-500': '#F04438',
  'error-600': '#D92D20',
  'error-700': '#B42318',
  'error-800': '#912018',
  'error-900': '#7A271A',
  'error-950': '#55160C',

  'success-25': '#F6FEF9',
  'success-50': '#ECFDF3',
  'success-100': '#D1FADF',
  'success-200': '#ABEFC6',
  'success-300': '#75E0A7',
  'success-400': '#47CD89',
  'success-500': '#17B26A',
  'success-600': '#039855',
  'success-700': '#067647',
  'success-800': '#05603A',
  'success-900': '#054F31',
  'success-950': '#023320',

  'warning-25': '#FFFCF5',
  'warning-50': '#FFFAEB',
  'warning-100': '#FEF0C7',
  'warning-200': '#FEDF89',
  'warning-300': '#FEC84B',
  'warning-400': '#FDB022',
  'warning-500': '#F79009',
  'warning-600': '#DC6803',
  'warning-700': '#B54708',
  'warning-800': '#93370D',
  'warning-900': '#7A2E0E',
  'warning-950': '#4E1D09',

  'gray-25': '#FDFDFD',
  'gray-50': '#FAFAFA',
  'gray-100': '#F5F5F5',
  'gray-200': '#E9EAEB',
  'gray-300': '#D5D7DA',
  'gray-400': '#A4A7AE',
  'gray-500': '#717680',
  'gray-600': '#535862',
  'gray-700': '#414651',
  'gray-800': '#252B37',
  'gray-900': '#181D27',
  'gray-950': '#0A0D12'
}
